import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SourceMaintenanceModalComponent } from './source-maintenance-modal.component';

@Injectable()
export class SourceMaintenanceModalService {

    constructor(private readonly dialog: MatDialog) { }

    showModal() {
        let dialogRef: MatDialogRef<SourceMaintenanceModalComponent>;

        dialogRef = this.dialog.open(
            SourceMaintenanceModalComponent,
            {
                disableClose: true,
                panelClass: 'tprecm-modal-panel',
                height: '94vh',
            }
        );

        return dialogRef;
    }
}
